import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import { getHoneycombRailHexColour } from '../../../../../helpers/getHexColorCode';
import { getPatternImages } from '../../../../../helpers/getPatternImages';

export const HoneycombSmartFit = (props: React.SVGProps<SVGSVGElement>) => {
  const [state] = useService(productBuilderMachine);
  const patternUrl = getPatternImages(state);
  var lightGuards =
    typeof state.context.custom.lightGuards === 'number' ? 'Yes' : '';

  const [width, height] = state.context.custom.measurements
    ? (state.context.custom.measurements as string)
        .split('x')
        .map(value => parseInt(value))
    : [0, 0];

  const squareMetreSize = (width * height) / 1000000;

  const railColour = state.context.custom.railColour
    ? state.context.custom.railColour
    : 'White';
  const railColourHex = getHoneycombRailHexColour(railColour);

  const isSmartfit25SingleCell =
    state.context.custom.cellDesign &&
    state.context.custom.cellDesign === 'Single Cell 25mm'
      ? true
      : false;

  if (
    (lightGuards !== 'Yes' &&
      width < 1270 &&
      squareMetreSize < 2.6 &&
      isSmartfit25SingleCell) ||
    (lightGuards !== 'Yes' && !isSmartfit25SingleCell)
  ) {
    return (
      <svg
        id="prefix__Layer_1"
        data-name="Layer 1"
        viewBox="0 0 549.1 409"
        {...props}
        preserveAspectRatio="none"
      >
        <defs>
          <pattern
            id="hcSmartFit"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patternUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <style>
            {`.prefix__cls-2{fill:${railColourHex}}.prefix__cls-3{fill:none;stroke:#c6c6c6;stroke-miterlimit:10;stroke-width:1.5px}.prefix__cls-4{fill:#878787}`}
          </style>
        </defs>
        <path fill="url(#hcSmartFit)" d="M2.4 89.5h544.2v235H2.4z" />
        <path
          className="prefix__cls-2"
          d="M523.9 328.3h25.2v-5H0v5h31.8M31.8 328.3h492.1M0 88.3h549.1v5H0z"
        />
        <path className="prefix__cls-3" d="M520.47 4.94v83.32" />
        <rect
          className="prefix__cls-4"
          x={507.81}
          width={14.25}
          height={1.48}
          rx={0.29}
        />
        <path
          className="prefix__cls-2"
          d="M522.05 4.65V1.18a.28.28 0 00-.28-.29h-3.52a.3.3 0 01-.25-.17l-.25-.55a.28.28 0 00-.26-.17h-4.76a.3.3 0 00-.26.17l-.25.55a.28.28 0 01-.26.17h-3.83a.29.29 0 00-.29.29v3.47a.29.29 0 00.29.29h13.66a.28.28 0 00.26-.29z"
        />
        <path className="prefix__cls-3" d="M28.61 4.94v83.32" />
        <rect
          className="prefix__cls-4"
          x={27.03}
          width={14.25}
          height={1.48}
          rx={0.29}
        />
        <path
          className="prefix__cls-2"
          d="M27 4.65V1.18a.29.29 0 01.29-.29h3.52a.3.3 0 00.28-.17l.25-.55a.3.3 0 01.27-.17h4.75a.29.29 0 01.27.17l.25.55a.3.3 0 00.24.17H41a.28.28 0 01.29.29v3.47a.28.28 0 01-.29.29H27.32a.29.29 0 01-.32-.29z"
        />
        <path className="prefix__cls-3" d="M520.47 328.3v75.76" />
        <rect
          className="prefix__cls-4"
          x={507.81}
          y={407.52}
          width={14.25}
          height={1.48}
          rx={0.29}
        />
        <path
          className="prefix__cls-2"
          d="M521.78 404.06h-13.66a.29.29 0 00-.29.29v3.47a.29.29 0 00.29.29H512a.28.28 0 01.26.17l.25.55a.3.3 0 00.26.17h4.76a.28.28 0 00.26-.17l.25-.55a.3.3 0 01.26-.17h3.52a.28.28 0 00.28-.29v-3.47a.28.28 0 00-.32-.29z"
        />
        <path className="prefix__cls-3" d="M28.61 328.3v75.76" />
        <rect
          className="prefix__cls-4"
          x={27.03}
          y={407.52}
          width={14.25}
          height={1.48}
          rx={0.29}
        />
        <path
          className="prefix__cls-2"
          d="M27 404.35a.29.29 0 01.29-.29H41a.28.28 0 01.29.29v3.47a.28.28 0 01-.29.29h-3.88a.3.3 0 00-.24.17l-.25.55a.29.29 0 01-.27.17h-4.75a.3.3 0 01-.24-.17l-.25-.55a.3.3 0 00-.28-.17h-3.52a.29.29 0 01-.29-.29v-3.47z"
        />
      </svg>
    );
  } else if (
    lightGuards !== 'Yes' &&
    (width >= 1270 || squareMetreSize >= 2.6) &&
    isSmartfit25SingleCell
  ) {
    return (
      <svg viewBox="0 0 554.3 409" {...props} preserveAspectRatio="none">
        <defs>
          <pattern
            id="hcSmartFit"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patternUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <style>
            {`.prefix__cls-2{fill:${railColourHex}}.prefix__cls-3{fill:none;stroke:#c6c6c6;stroke-miterlimit:10;stroke-width:1.5px}.prefix__cls-4{fill:#878787}`}
          </style>
        </defs>
        <g id="prefix__Blind">
          <path fill="url(#hcSmartFit)" d="M2.42 89.51h544.21v234.86H2.42z" />
          <path
            className="prefix__cls-2"
            d="M0 323.12h549.06v5H0zM0 88.26h549.06v5H0z"
          />
          <path className="prefix__cls-3" d="M522.35 403.94v-75.82" />
          <rect
            className="prefix__cls-4"
            x={509.69}
            y={407.4}
            width={14.25}
            height={1.48}
            rx={0.29}
          />
          <path
            className="prefix__cls-2"
            d="M523.93 404.23v3.47a.29.29 0 01-.29.29h-3.51a.29.29 0 00-.26.17l-.25.55a.3.3 0 01-.26.17h-4.76a.3.3 0 01-.26-.17l-.25-.55a.3.3 0 00-.26-.17H510a.29.29 0 01-.29-.29v-3.47a.29.29 0 01.29-.29h13.66a.29.29 0 01.27.29z"
          />
          <path className="prefix__cls-3" d="M274.53 403.94v-75.82" />
          <rect
            className="prefix__cls-4"
            x={267.41}
            y={407.4}
            width={14.25}
            height={1.48}
            rx={0.29}
          />
          <path
            className="prefix__cls-2"
            d="M281.65 404.23v3.47a.29.29 0 01-.29.29h-3.51a.3.3 0 00-.27.17l-.24.55a.3.3 0 01-.27.17h-4.75a.29.29 0 01-.26-.17l-.25-.55a.3.3 0 00-.26-.17h-3.86a.28.28 0 01-.28-.29v-3.47a.28.28 0 01.28-.29h13.67a.29.29 0 01.29.29z"
          />
          <path className="prefix__cls-3" d="M274.53 5v83.26" />
          <rect
            className="prefix__cls-4"
            x={267.41}
            y={0.06}
            width={14.25}
            height={1.48}
            rx={0.29}
          />
          <path
            className="prefix__cls-2"
            d="M281.65 4.71V1.24a.29.29 0 00-.29-.29h-3.51a.28.28 0 01-.27-.17l-.24-.55a.3.3 0 00-.27-.17h-4.75a.29.29 0 00-.26.17l-.25.55a.28.28 0 01-.26.17h-3.86a.28.28 0 00-.28.29v3.47a.28.28 0 00.28.29h13.67a.29.29 0 00.29-.29z"
          />
          <path className="prefix__cls-3" d="M30.49 403.94v-75.82" />
          <rect
            className="prefix__cls-4"
            x={28.91}
            y={407.4}
            width={14.25}
            height={1.48}
            rx={0.29}
            transform="rotate(-180 36.035 408.14)"
          />
          <path
            className="prefix__cls-2"
            d="M28.91 404.23v3.47a.29.29 0 00.29.29h3.52a.3.3 0 01.26.17l.25.55a.29.29 0 00.26.17h4.75a.3.3 0 00.27-.17l.25-.55A.29.29 0 0139 408h3.85a.29.29 0 00.29-.29v-3.47a.29.29 0 00-.29-.29H29.2a.29.29 0 00-.29.28z"
          />
          <path className="prefix__cls-3" d="M522.35 4.94v83.32" />
          <rect
            className="prefix__cls-4"
            x={509.69}
            width={14.25}
            height={1.48}
            rx={0.29}
          />
          <path
            className="prefix__cls-2"
            d="M523.93 4.65V1.18a.29.29 0 00-.29-.29h-3.51a.29.29 0 01-.26-.17l-.25-.55a.3.3 0 00-.26-.17h-4.76a.3.3 0 00-.26.17l-.25.55a.3.3 0 01-.26.17H510a.29.29 0 00-.29.29v3.47a.29.29 0 00.29.29h13.66a.29.29 0 00.27-.29z"
          />
          <path className="prefix__cls-3" d="M30.49 4.94v83.32" />
          <rect
            className="prefix__cls-4"
            x={28.91}
            width={14.25}
            height={1.48}
            rx={0.29}
            transform="rotate(180 36.035 .74)"
          />
          <path
            className="prefix__cls-2"
            d="M28.91 4.65V1.18a.29.29 0 01.29-.29h3.52A.3.3 0 0033 .72l.25-.55a.29.29 0 01.24-.17h4.75a.3.3 0 01.27.17l.25.55a.29.29 0 00.24.17h3.85a.29.29 0 01.29.29v3.47a.29.29 0 01-.29.29H29.2a.29.29 0 01-.29-.29z"
          />
        </g>
      </svg>
    );
  } else if (
    typeof lightGuards !== 'undefined' &&
    lightGuards === 'Yes' &&
    (width > 1270 || squareMetreSize > 2.6) &&
    isSmartfit25SingleCell
  ) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="prefix__Layer_1"
        data-name="Layer 1"
        viewBox="0 0 550 409"
        {...props}
        preserveAspectRatio="none"
      >
        <defs>
          <pattern
            id="hcSmartFit"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patternUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <style>
            {`.prefix__cls-1{fill:#afafaf}.prefix__cls-3{fill:${railColourHex}}.prefix__cls-4{fill:none;stroke:#c6c6c6;stroke-miterlimit:10;stroke-width:1.5px}.prefix__cls-5{fill:#878787}`}
          </style>
        </defs>
        <g id="prefix__Light_guard" data-name="Light guard">
          <path
            className="prefix__cls-1"
            d="M0 0h14.55v409.05H0zM534.51 0h14.55v409.05h-14.55z"
          />
        </g>
        <g id="prefix__Blind">
          <path fill="url(#hcSmartFit)" d="M2.42 89.59h544.21v234.86H2.42z" />
          <path
            className="prefix__cls-3"
            d="M0 323.2h549.06v5H0zM0 88.34h549.06v5H0z"
          />
          <path className="prefix__cls-4" d="M522.35 404.02V328.2" />
          <rect
            className="prefix__cls-5"
            x={509.69}
            y={407.48}
            width={14.25}
            height={1.48}
            rx={0.29}
          />
          <path
            className="prefix__cls-3"
            d="M523.93 404.23v3.47a.29.29 0 01-.29.29h-3.51a.3.3 0 00-.26.17l-.25.55a.3.3 0 01-.26.17h-4.76a.3.3 0 01-.26-.17l-.25-.55a.3.3 0 00-.26-.17H510a.29.29 0 01-.29-.29v-3.47a.29.29 0 01.29-.29h13.66a.29.29 0 01.27.29z"
            transform="translate(0 .08)"
          />
          <path className="prefix__cls-4" d="M274.53 404.02V328.2" />
          <rect
            className="prefix__cls-5"
            x={267.41}
            y={407.48}
            width={14.25}
            height={1.48}
            rx={0.29}
          />
          <path
            className="prefix__cls-3"
            d="M281.65 404.23v3.47a.29.29 0 01-.29.29h-3.51a.3.3 0 00-.27.17l-.24.55a.3.3 0 01-.27.17h-4.75a.3.3 0 01-.26-.17l-.25-.55a.3.3 0 00-.26-.17h-3.86a.29.29 0 01-.28-.28v-3.47a.29.29 0 01.27-.29h13.68a.29.29 0 01.29.28z"
            transform="translate(0 .08)"
          />
          <path className="prefix__cls-4" d="M274.53 5.08v83.26" />
          <rect
            className="prefix__cls-5"
            x={267.41}
            y={0.14}
            width={14.25}
            height={1.48}
            rx={0.29}
          />
          <path
            className="prefix__cls-3"
            d="M281.65 4.71V1.24a.29.29 0 00-.29-.29h-3.51a.27.27 0 01-.27-.17l-.24-.55a.3.3 0 00-.27-.17h-4.75a.3.3 0 00-.26.17l-.25.55a.29.29 0 01-.26.17h-3.86a.29.29 0 00-.28.28v3.48a.29.29 0 00.27.29h13.68a.29.29 0 00.29-.29z"
            transform="translate(0 .08)"
          />
          <path className="prefix__cls-4" d="M30.49 404.02V328.2" />
          <rect
            className="prefix__cls-5"
            x={28.91}
            y={407.49}
            width={14.25}
            height={1.48}
            rx={0.29}
          />
          <path
            className="prefix__cls-3"
            d="M28.91 404.23v3.47a.29.29 0 00.29.29h3.52a.3.3 0 01.26.17l.25.55a.3.3 0 00.26.17h4.75a.3.3 0 00.27-.17l.25-.55A.31.31 0 0139 408h3.85a.29.29 0 00.29-.29v-3.47a.29.29 0 00-.29-.29H29.2a.29.29 0 00-.29.28z"
            transform="translate(0 .08)"
          />
          <path className="prefix__cls-4" d="M522.35 5.02v83.32" />
          <rect
            className="prefix__cls-5"
            x={509.69}
            y={0.08}
            width={14.25}
            height={1.48}
            rx={0.29}
          />
          <path
            className="prefix__cls-3"
            d="M523.93 4.65V1.18a.29.29 0 00-.29-.29h-3.51a.3.3 0 01-.26-.17l-.25-.55a.3.3 0 00-.26-.17h-4.76a.3.3 0 00-.26.17l-.25.55a.3.3 0 01-.26.17H510a.29.29 0 00-.29.29v3.47a.29.29 0 00.29.29h13.66a.29.29 0 00.27-.29z"
            transform="translate(0 .08)"
          />
          <path className="prefix__cls-4" d="M30.49 5.02v83.32" />
          <rect
            className="prefix__cls-5"
            x={28.91}
            y={0.08}
            width={14.25}
            height={1.48}
            rx={0.29}
          />
          <path
            className="prefix__cls-3"
            d="M28.91 4.65V1.18a.29.29 0 01.29-.29h3.52A.3.3 0 0033 .72l.25-.55a.29.29 0 01.24-.17h4.75a.3.3 0 01.27.17l.25.55a.29.29 0 00.24.17h3.85a.29.29 0 01.29.29v3.47a.29.29 0 01-.29.29H29.2a.29.29 0 01-.29-.29z"
            transform="translate(0 .08)"
          />
        </g>
      </svg>
    );
  } else {
    return (
      <svg
        id="prefix__Layer_1"
        data-name="Layer 1"
        viewBox="0 0 554.3 409"
        {...props}
        preserveAspectRatio="none"
      >
        <defs>
          <pattern
            id="hcSmartFit"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patternUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <style>
            {`.prefix__cls-2{fill:${railColourHex}}.prefix__cls-3{fill:none;stroke:#c6c6c6;stroke-miterlimit:10;stroke-width:1.5px}.prefix__cls-4{fill:#878787}`}
          </style>
        </defs>
        <path fill="url(#hcSmartFit)" d="M5 89.5h544.2v235H5z" />
        <path
          className="prefix__cls-2"
          d="M526.5 328.2h22.8V409h5V0h-5.1v88.3H5V0H0v409h5v-80.8h29.4m0 0h492.1m22.7-4.9H5v-230h544.2z"
        />
        <path className="prefix__cls-3" d="M523.02 4.94v83.32" />
        <rect
          className="prefix__cls-4"
          x={510.37}
          width={14.25}
          height={1.48}
          rx={0.29}
        />
        <path
          className="prefix__cls-2"
          d="M524.6 4.65V1.18a.28.28 0 00-.28-.29h-3.51a.28.28 0 01-.26-.17l-.25-.55A.3.3 0 00520 0h-4.76a.3.3 0 00-.26.17l-.25.55a.28.28 0 01-.26.17h-3.82a.29.29 0 00-.3.29v3.47a.29.29 0 00.3.29h13.65a.28.28 0 00.3-.29z"
        />
        <path className="prefix__cls-3" d="M31.17 4.94v83.32" />
        <rect
          className="prefix__cls-4"
          x={29.59}
          width={14.25}
          height={1.48}
          rx={0.29}
        />
        <path
          className="prefix__cls-2"
          d="M29.59 4.65V1.18a.28.28 0 01.29-.29h3.52a.32.32 0 00.28-.17l.25-.55a.27.27 0 01.24-.17h4.75a.31.31 0 01.27.17l.25.55a.27.27 0 00.24.17h3.85a.29.29 0 01.29.29v3.47a.29.29 0 01-.29.29H29.88a.28.28 0 01-.29-.29z"
        />
        <path className="prefix__cls-3" d="M523.02 328.2v75.86" />
        <rect
          className="prefix__cls-4"
          x={510.37}
          y={407.52}
          width={14.25}
          height={1.48}
          rx={0.29}
        />
        <path
          className="prefix__cls-2"
          d="M524.33 404.06h-13.65a.29.29 0 00-.3.29v3.47a.29.29 0 00.3.29h3.82a.28.28 0 01.26.17l.25.55a.3.3 0 00.26.17H520a.3.3 0 00.27-.17l.25-.55a.28.28 0 01.26-.17h3.51a.28.28 0 00.28-.29v-3.47a.28.28 0 00-.24-.29z"
        />
        <path className="prefix__cls-3" d="M31.17 328.2v75.86" />
        <rect
          className="prefix__cls-4"
          x={29.59}
          y={407.52}
          width={14.25}
          height={1.48}
          rx={0.29}
        />
        <path
          className="prefix__cls-2"
          d="M29.59 404.35a.28.28 0 01.29-.29h13.65a.29.29 0 01.29.29v3.47a.29.29 0 01-.29.29h-3.85a.27.27 0 00-.24.17l-.25.55a.31.31 0 01-.27.17h-4.75a.27.27 0 01-.24-.17l-.25-.55a.32.32 0 00-.28-.17h-3.52a.28.28 0 01-.29-.29v-3.47z"
        />
      </svg>
    );

    return (
      <svg viewBox="0 0 549.06 408.88" {...props}>
        <defs>
          <style>
            {
              '.prefix__cls-2{fill:#939391}.prefix__cls-3{fill:none;stroke:#c6c6c6;stroke-miterlimit:10;stroke-width:1.5px}.prefix__cls-4{fill:#878787}'
            }
          </style>
        </defs>
        <g id="prefix__Blind">
          <path fill="#c9c1b4" d="M2.42 89.51h544.21v234.86H2.42z" />
          <path
            className="prefix__cls-2"
            d="M0 323.12h549.06v5H0zM0 88.26h549.06v5H0z"
          />
          <path className="prefix__cls-3" d="M522.35 403.94v-75.82" />
          <rect
            className="prefix__cls-4"
            x={509.69}
            y={407.4}
            width={14.25}
            height={1.48}
            rx={0.29}
          />
          <path
            className="prefix__cls-2"
            d="M523.93 404.23v3.47a.29.29 0 01-.29.29h-3.51a.29.29 0 00-.26.17l-.25.55a.3.3 0 01-.26.17h-4.76a.3.3 0 01-.26-.17l-.25-.55a.3.3 0 00-.26-.17H510a.29.29 0 01-.29-.29v-3.47a.29.29 0 01.29-.29h13.66a.29.29 0 01.27.29z"
          />
          <path className="prefix__cls-3" d="M274.53 403.94v-75.82" />
          <rect
            className="prefix__cls-4"
            x={267.41}
            y={407.4}
            width={14.25}
            height={1.48}
            rx={0.29}
          />
          <path
            className="prefix__cls-2"
            d="M281.65 404.23v3.47a.29.29 0 01-.29.29h-3.51a.3.3 0 00-.27.17l-.24.55a.3.3 0 01-.27.17h-4.75a.29.29 0 01-.26-.17l-.25-.55a.3.3 0 00-.26-.17h-3.86a.28.28 0 01-.28-.29v-3.47a.28.28 0 01.28-.29h13.67a.29.29 0 01.29.29z"
          />
          <path className="prefix__cls-3" d="M274.53 5v83.26" />
          <rect
            className="prefix__cls-4"
            x={267.41}
            y={0.06}
            width={14.25}
            height={1.48}
            rx={0.29}
          />
          <path
            className="prefix__cls-2"
            d="M281.65 4.71V1.24a.29.29 0 00-.29-.29h-3.51a.28.28 0 01-.27-.17l-.24-.55a.3.3 0 00-.27-.17h-4.75a.29.29 0 00-.26.17l-.25.55a.28.28 0 01-.26.17h-3.86a.28.28 0 00-.28.29v3.47a.28.28 0 00.28.29h13.67a.29.29 0 00.29-.29z"
          />
          <path className="prefix__cls-3" d="M30.49 403.94v-75.82" />
          <rect
            className="prefix__cls-4"
            x={28.91}
            y={407.4}
            width={14.25}
            height={1.48}
            rx={0.29}
            transform="rotate(-180 36.035 408.14)"
          />
          <path
            className="prefix__cls-2"
            d="M28.91 404.23v3.47a.29.29 0 00.29.29h3.52a.3.3 0 01.26.17l.25.55a.29.29 0 00.26.17h4.75a.3.3 0 00.27-.17l.25-.55A.29.29 0 0139 408h3.85a.29.29 0 00.29-.29v-3.47a.29.29 0 00-.29-.29H29.2a.29.29 0 00-.29.28z"
          />
          <path className="prefix__cls-3" d="M522.35 4.94v83.32" />
          <rect
            className="prefix__cls-4"
            x={509.69}
            width={14.25}
            height={1.48}
            rx={0.29}
          />
          <path
            className="prefix__cls-2"
            d="M523.93 4.65V1.18a.29.29 0 00-.29-.29h-3.51a.29.29 0 01-.26-.17l-.25-.55a.3.3 0 00-.26-.17h-4.76a.3.3 0 00-.26.17l-.25.55a.3.3 0 01-.26.17H510a.29.29 0 00-.29.29v3.47a.29.29 0 00.29.29h13.66a.29.29 0 00.27-.29z"
          />
          <path className="prefix__cls-3" d="M30.49 4.94v83.32" />
          <rect
            className="prefix__cls-4"
            x={28.91}
            width={14.25}
            height={1.48}
            rx={0.29}
            transform="rotate(180 36.035 .74)"
          />
          <path
            className="prefix__cls-2"
            d="M28.91 4.65V1.18a.29.29 0 01.29-.29h3.52A.3.3 0 0033 .72l.25-.55a.29.29 0 01.24-.17h4.75a.3.3 0 01.27.17l.25.55a.29.29 0 00.24.17h3.85a.29.29 0 01.29.29v3.47a.29.29 0 01-.29.29H29.2a.29.29 0 01-.29-.29z"
          />
        </g>
      </svg>
    );
  }
};
